const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Invitation Manager Directive to display a list or table with users to manage
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Resource} Users the resource defined to get and set Invitation data
 */
app.directive('imageLightbox', [function () {
  return {
    restrict: 'E',
    scope: {
        url: '=',
        lightboxStatus: '='
    },
    replace: true,
    template: require('../../templates/directives/image-lightbox.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
    }],
    controllerAs: 'lightbox'
  };
}]);